import React from 'react';
import { ORG_LABELS } from '../config';

const COLORS = { della: '#1f75e0', 'vrd canada': '#01497c', vezita: '#e8770a' };

/** Organization label with a dot in its colour. `orgKey` is della / vezita / vrd canada. */
export default function OrgTag({ orgKey }) {
  return (
    <span className="row" style={{ gap: 6, flexWrap: 'nowrap', whiteSpace: 'nowrap' }}>
      <i style={{ width: 8, height: 8, borderRadius: '50%', background: COLORS[orgKey] || '#98a2b3', display: 'inline-block' }} />
      {ORG_LABELS[orgKey] || '—'}
    </span>
  );
}
